import Icon from '../components/Icon.vue'

Icon.register({"fighter-jet":{"width":640,"height":512,"paths":[{"d":"M544 224L416 208 368 192H344L227.2 44H266.7C278.3 44 288 41.4 288 38S278.3 32 266.7 32H152V44H168V208H120L53.3 128H18.7L8 138.7V208H16V224H64V226.7L0 234.7V277.3L64 285.3V288H16V304H8V373.3L18.7 384H53.3L120 304H168V468H152V480H266.7C278.3 480 288 477.4 288 474S278.3 468 266.7 468H227.2L344 320H368L416 304 544 288C640 266.7 640 261.4 640 256 640 250.6 640 245.3 544 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/fighter-jet.js
// module id = null
// module chunks = 